import { Router } from "@reach/router";
import ProjectDetail from "../../templates/project-details";
import React from "react";
import BlogDetails from "../../templates/blog-details";
// import ProjectDetail from "../../templates/project-detail"
//
// This is a client-side only template that will catch all
// requests to /portfolio/:slug
const ProjectDetailPage = () => {
  return (
    <Router basepath="/blogs">
      <BlogDetails path="/:slug" />
    </Router>
  );
};

export default ProjectDetailPage;
